// eslint-disable-next-line no-unused-vars
import styles from "../../../styles/selectBar.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { sortStudents } from "../studentSlice";

const StudentSelectBar = () => {
  const dispatch = useDispatch();
  const [typeSelect, setTypeSelect] = useState("all");

  const handleTypeSelect = (value) => {
    setTypeSelect(value);
    dispatch(sortStudents(value));
  };

  return (
    <select
      id="typeSelect"
      value={typeSelect}
      onChange={(e) => handleTypeSelect(e.target.value)}
      style={{
        padding: "10px",
        fontSize: "16px",
        color: "#737373",
        width: "180px",
        border: "1px solidrgb(29, 22, 22)",
        borderRadius: "5px",
        cursor: "pointer",
        backgroundColor: "white",
      }}
      className="customSelect"
    >
      <option value="all">정렬 방법 선택</option>
      <option value="name">이름순 정렬</option>
      <option value="grade">학년순 정렬</option>
      <option value="level">반이름순 정렬</option>
    </select>
  );
};

export default StudentSelectBar;
